"use strict";

class SalesApplicationAddSaleController {

  constructor($scope,
              $window,
              $filter,
              $timeout,
              SSAppService,
              SSHttpService,
              SSUtilService,
              SSDateService,
              SSAlertService,
              SSConfigService,
              SSConfirmationService,
              SSUserService,
              SSEoiService
  ) {
      const self = this;

      self.$scope = $scope;
      self.$window = $window;
      self.filter = $filter;
      self.$timeout = $timeout;

      self.SSAppService = SSAppService;
      self.SSHttpService = SSHttpService;
      self.SSUtilService = SSUtilService;
      self.SSDateService = SSDateService;
      self.SSAlertService = SSAlertService;
      self.SSConfigService = SSConfigService;
      self.SSConfirmationService = SSConfirmationService;
      self.SSUserService = SSUserService;
      self.SSEoiService = SSEoiService;

      self.data = SHOWSUITE.data;

      self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
      self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
      self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
      self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
      self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
      self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;
      
      self.SALE_STATUS_DRAFT = SHOWSUITE.SALE_STATUS_DRAFT;
      self.SALE_STATUS_PENDING = SHOWSUITE.SALE_STATUS_PENDING;
      self.SALE_STATUS_SUBMITTED = SHOWSUITE.SALE_STATUS_SUBMITTED;
      self.SALE_STATUS_VERIFIED = SHOWSUITE.SALE_STATUS_VERIFIED;
      self.SALE_STATUS_APPROVED = SHOWSUITE.SALE_STATUS_APPROVED;
      self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
      self.SALE_STATUS_OTP = SHOWSUITE.SALE_STATUS_OTP;

      self.PROPERTY_STATUS_DRAFT = SHOWSUITE.PROPERTY_STATUS_DRAFT;
      self.PROPERTY_STATUS_REVIEW = SHOWSUITE.PROPERTY_STATUS_REVIEW;
      self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED;
      self.PROPERTY_STATUS_REJECTED = SHOWSUITE.PROPERTY_STATUS_REJECTED;
      self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED;
      self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED;

      self.SALE_STATUS_CHEQUE_ENTERED = SHOWSUITE.SALE_STATUS_CHEQUE_ENTERED;
      self.SALE_STATUS_SPA_ENTERED = SHOWSUITE.SALE_STATUS_SPA_ENTERED;
      self.SALE_STATUS_EXPIRED = SHOWSUITE.SALE_STATUS_EXPIRED;
      self.SALE_STATUS_EXTENDED = SHOWSUITE.SALE_STATUS_EXTENDED;
      self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
      self.SALE_STATUS_ABORTED = SHOWSUITE.SALE_STATUS_ABORTED;
      self.SALE_STATUS_INVALID = SHOWSUITE.SALE_STATUS_INVALID;
      self.SALE_STATUS_DONE = SHOWSUITE.SALE_STATUS_DONE;
      self.SALE_STATUS_DELETED = SHOWSUITE.SALE_STATUS_DELETED;

      self.BROKER_ROLE_MAIN_BROKER = SHOWSUITE.BROKER_ROLE_MAIN_BROKER;
      self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED;
      self.ASSET_MODEL_SALE_DOCUMENT = SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT;

      self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS;
      self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM;
      self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
      self.PROPERTY_DOCUMENT_KIND_PDI_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PDI_FORM;
      self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM;
      self.PROPERTY_DOCUMENT_KIND_AML = SHOWSUITE.PROPERTY_DOCUMENT_KIND_AML;

      self.INSTRUMENT_TYPE_CHEQUE = SHOWSUITE.INSTRUMENT_TYPE_CHEQUE;
      self.INSTRUMENT_TYPE_CASHIERS_ORDER = SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER;
      self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER;
      self.INSTRUMENT_TYPE_CASH_IN = SHOWSUITE.INSTRUMENT_TYPE_CASH_IN;
      self.INSTRUMENT_TYPE_GIRO = SHOWSUITE.INSTRUMENT_TYPE_GIRO;
      self.INSTRUMENT_TYPE_DEBIT_CARD = SHOWSUITE.INSTRUMENT_TYPE_DEBIT_CARD;
      self.INSTRUMENT_TYPE_FAST_CASH = SHOWSUITE.INSTRUMENT_TYPE_FAST_CASH;

      self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_FRONT;
      self.PROPERTY_DOCUMENT_KIND_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_BACK;
      self.PROPERTY_DOCUMENT_KIND_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PASSPORT;
      self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE;
      self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION;
      self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM;
      self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;

      self.PROPERTY_DOCUMENT_FORMAT_IMG = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_IMG;
      self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;

      self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
      self.BUYER_TYPE_COMPANY = SHOWSUITE.BUYER_TYPE_COMPANY;

      self.IDENTITY_TYPE_FOREIGNER = SHOWSUITE.IDENTITY_TYPE_FOREIGNER;

      self.UNIT_CATEGORY_COMMERCIAL = SHOWSUITE.UNIT_CATEGORY_COMMERCIAL;

      self.timeout_promise = null;

      self.has_access = false;
      if (self.SSUserService.isDeveloper()) {
          self.init();
          self.has_access = true;
      }
  }

  init() {
    const self = this;

    self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_UNIT_SELECTION_PAGE;
  }

  getUnitNumber(unit){
    const self = this;

    if(unit.length < 1){
      return '-';
    }
    return self.SSUtilService.getFullUnitNumber1(unit, false);
  }

  goBack() {
    const self = this;

    self.SSAlertService.message = null

    switch(self.SSEoiService.currentPage) {
        case self.SSEoiService.SEARCH_BUYER_PAGE:
            console.log("Shouldn't display back button, should only abort as there is not place to back");
            break;
        case self.SSEoiService.LAUNCH_UNIT_SELECTION_PAGE:
            console.log("Shouldn't display back button!!");
            break;
        case self.SSEoiService.LAUNCH_CO_BROKER_SELECTION_PAGE:
            self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_UNIT_SELECTION_PAGE;       
            break;
        case self.SSEoiService.LAUNCH_BUYER_PARTICULAR_PAGE:
            self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_CO_BROKER_SELECTION_PAGE;
            break;
        // Added new page 'ADD DISCOUNTS'
        case self.SSEoiService.LAUNCH_ADD_DISCOUNTS_PAGE:
            self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_BUYER_PARTICULAR_PAGE;
            break;
        case self.SSEoiService.LAUNCH_PDI_PAGE:
            self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_ADD_DISCOUNTS_PAGE;
            break;
        case self.SSEoiService.LAUNCH_DOCUMENT_UPLOAD_PAGE:
            self.$timeout(function() { 
                //Prepare bank & relationship checking
                $.each(self.SSEoiService.sale_obj.instruments, function (index, instrument) {
                    if (!self.SSEoiService.banks.find(x => x.name === instrument.bank_name)) {
                        instrument.bank_name_other = instrument.bank_name;
                        instrument.bank_name = "Others";
                    }
                    if (instrument.relationship_with_account_holder) {
                        instrument.relationshipCheck = true;
                        if (self.SSEoiService.relationships.find(x => x.name === instrument.relationship_with_account_holder)) {
                            instrument.relationship = instrument.relationship_with_account_holder;
                        } else {
                            instrument.relationship = "OTHERS";
                            instrument.relationship_other = instrument.relationship_with_account_holder;
                        }
                    }

                    if (instrument.cheque_date) {
                        instrument.cheque_date = moment(self.parseDate(instrument.cheque_date)).format('YYYY-MM-DD');
                    }

                    if (instrument.bank_in_date) {
                        instrument.bank_in_date = moment(self.parseDate(instrument.bank_in_date)).format('YYYY-MM-DD');
                    }
                });

                self.$timeout(function() { 
                    $(".dashboard-select#relationship").niceSelect('update');
                    $(".dashboard-select#documentUploadBank").niceSelect('update');
                    $(".dashboard-select[id^=format]").niceSelect('update');
                    $(".dashboard-select[id^=payment_type]").niceSelect('update');
                    $(".datepicker").datepicker( { dateFormat: "yy-mm-dd" } );
                });
            });
            self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_PDI_PAGE;
            break;
        case self.SSEoiService.LAUNCH_SUMMARY_PAGE:
            self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_DOCUMENT_UPLOAD_PAGE;
            break;
        default:
            console.log("Invalid page url, something is wrong!");
    }
    window.scrollTo(0, 0);
  }

  proceedUnitSelectionPage() {
    const self = this;

    self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_UNIT_SELECTION_PAGE;
  }

  proceedBuyerParticularsPage() {
    const self = this;

    self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_BUYER_PARTICULAR_PAGE;
  }

  proceedCoBrokerSelectionPage() {
    const self = this;

    self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_CO_BROKER_SELECTION_PAGE;    
  }

  // New page for 'DMS: ADD SALE'
  proceedAddDiscountsPage() {
    const self = this;

    self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_ADD_DISCOUNTS_PAGE;    
  }

  proceedDocumentUploadPage() {
    const self = this;

    self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_DOCUMENT_UPLOAD_PAGE;    
  }

  proceedPdiPage() {
    const self = this;

    self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_PDI_PAGE; 
  }

  generateOTP() {
    const self = this;

    self.getOtpDocs();
    self.selected_otp_document = self.otp_documents[0].id;

      /** WEB-2918 DMS: OTP Date - Add permissions **/
    self.selected_property_id = self.SSEoiService.property.id;

    self.otp_date = moment().format('DD/MM/YYYY');
    $('#developerSaleApplicationGenerateOTPModal').modal('show');

  }

  parseDate(date) {
    const self = this;
    const parsed = Date.parse(date);
    if (!isNaN(parsed)) {
        return parsed;
    }

    return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
  }

  getOtpDocs(){
    const self = this;
    self.otp_documents= [];
    self.property_documents = self.SSEoiService.property.property_documents;

    if(!self.property_documents) {
      self.otp_documents= [{
        id: null,
        name: 'Default'
      }];
      return;
    }

    $.each(self.property_documents, function(i,e){
      console.log(e);
      if(e.document_kind == self.PROPERTY_DOCUMENT_KIND_OTP){
        //self.otp_documents = $.extend({},self.otp_documents,e);
        self.otp_documents.push(e);

      }
    });

    if (self.otp_documents.length == 0) {
      self.otp_documents= [{
        id: null,
        name: 'Default'
      }];
    }

  }

  _generateOTP(send_email, regenerate, sale) {
    const self = this;

    if(self.edit_otp){
      // Open OTP in editor
      self.$window.location.href = '/developer/sales/' + self.SSEoiService.sale_obj.id + '/editotp';
      return;
    }

    let url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/generate-otp';
    let params = {
      'send_email': send_email,
      'otp_date': self.SSDateService.formateWithTimeAsNoon(self.otp_date),
      'regenerate': true,
      'document'  : self.selected_otp_document,
      'timezone': self.SSDateService.getLocalTimezone()
    };

    loading(true);
    self.SSHttpService.postAPIRequest(url, params).then(function (response) {
        loading(false);
        if (response instanceof Error) {
            self.SSAlertService.parseAndDisplayError(response);
            return;
        }

        self.hideModals();
        self.SSEoiService.sale_obj.status = self.SALE_STATUS_OTP;
        self.SSEoiService.sale_obj["sale_document"] = response.data.sale_document;

        self.SSAlertService.success('OTP is generated successfully.');
        self.viewOTP();

        self.completeSalePing();
    });
  }

  viewOTP() {
    const self = this;

    if (self.SSEoiService.sale_obj["sale_document"]) {
      let url = 'sec/assets/presigned-url';
      let params = {
        model: self.ASSET_MODEL_SALE_DOCUMENT,
        id: self.SSEoiService.sale_obj["sale_document"].id
      };

      loading(true);
      self.SSHttpService.getAPIRequest(url, params).then(function (response) {
        loading(false);
        if (response instanceof Error) {
          self.SSAlertService.parseAndDisplayError(response);
          return;
        }

        // Open OTP in new tab
        window.open(response.data.presigned_url, '_blank');
      });
    }
  }

  hideModals() {
    const self = this;

    self.showOTPModal = false;

    if ($('#developerSaleApplicationGenerateOTPModal').is(':visible')) $('#developerSaleApplicationGenerateOTPModal').modal('hide');
  }

  viewPDFObject(file_url) {
    window.open(file_url, '_blank');
  }

  pingSaleStatus() {
    const self = this;

    if (self.timeout_promise) {
        self.$timeout.cancel(self.timeout_promise);
    }

    let url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/creation-ping';

    self.SSHttpService.postAPIRequest(url).then(
        function (response) {
            if (response instanceof Error) {
                //Popup show
                self.SSAlertService.danger("Error!", "Please contact administrator!");
                return;
            }

            self.timeout_promise = self.$timeout(function () {
                self.pingSaleStatus();
            }, 30000); // 30 seconds delay
        }
    );
  }

  completeSalePing() {
    const self = this;

    if (self.timeout_promise) {
        self.$timeout.cancel(self.timeout_promise);
    }

    let url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/creation-done';

    self.SSHttpService.postAPIRequest(url).then(
        function (response) {
            if (response instanceof Error) {
                //Popup show
                self.SSAlertService.danger("Error!", "Please contact administrator!");
                return;
            }

            //Redirect to applications
            window.location.href = '/developer/sales/applications';
        }
    );
  }
}

SalesApplicationAddSaleController.$inject = [
    '$scope',
    '$window',
    '$filter',
    '$timeout',
    'SSAppService',
    'SSHttpService',
    'SSUtilService',
    'SSDateService',
    'SSAlertService',
    'SSConfigService',
    'SSConfirmationService',
    'SSUserService',
    'SSEoiService',
];
app.controller('SalesApplicationAddSaleController', SalesApplicationAddSaleController);